import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { Screens, Stacks } from 'components/Navigation/types';
import { theme } from 'lib/theme';
import React from 'react';
import { UI_DATE_FORMAT_LONG } from 'lib/constants';
import { Avatar } from 'components/Avatar';
import { ItemDetails } from 'components/ItemDetails';
import { useSelector } from 'hooks/useSelector';
import {
  selectAseReference,
  selectAseDetails,
  selectAseComplianceSubtype,
} from 'store/assessments/selectors';
import { rbAddReferencePrefix } from 'lib/riskbase';
import { format } from 'date-fns';
import { Txt } from 'components/Txt';
import { Card } from 'components/Card';
import { navigateScreenAware } from 'components/Navigation/navigationRef';
import { ExplorerNavigation } from './types';

export const ExplorerSummaryRow: React.FC<{
  navigation: ExplorerNavigation;
}> = () => {
  const reference = useSelector(selectAseReference);
  const details = useSelector(selectAseDetails);
  const complianceSubtype = useSelector(selectAseComplianceSubtype);
  const assessedBy = details.assessedBy.map((ab) => ab.name).join(', ');

  return (
    <Card margin={false}>
      <CardRow
        navigationIsSelected={{
          name: Screens.ASE_SUMMARY,
          params: {},
        }}
        onPress={() =>
          navigateScreenAware(Stacks.ASSESSMENT, Screens.ASE_SUMMARY, {})
        }
        childrenStyle={{
          alignItems: 'center',
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'center',
        }}
      >
        <Avatar
          icon={ICONS.CertificateLight}
          size={70}
          iconPadding={16}
          style={{ marginRight: theme.paddingHorizontal }}
        />
        <ItemDetails
          title={complianceSubtype.name}
          subtitle={`${format(
            new Date(details.assessedDate),
            UI_DATE_FORMAT_LONG,
          )}${assessedBy ? ` by ${assessedBy}` : ''}`}
          subsubtitle={
            <>
              {reference ? (
                rbAddReferencePrefix(reference)
              ) : (
                <>
                  {rbAddReferencePrefix('')}
                  <Txt
                    size="xsmall"
                    style={{ color: theme.colors.placeholder }}
                  >
                    000000
                  </Txt>
                </>
              )}
              {details.customReference ? ` • ${details.customReference}` : ''}
            </>
          }
        />
      </CardRow>
    </Card>
  );
};
